import { useState } from "react";
import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { ExpenseForm } from "./ExpenseForm";

export const TransactionDialog = ({ onSaved, label = "Catat pengeluaran", testId = "add-transaction-button" }) => {
  const [open, setOpen] = useState(false);
  return <>
    <button data-testid={testId} className="primary-btn" onClick={() => setOpen(true)}><Plus size={18} /> {label}</button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="kp-dialog" data-testid="transaction-dialog">
        <DialogHeader><DialogTitle>Catat pengeluaran</DialogTitle><DialogDescription>Lampirkan foto nota dan foto bukti barang. Pengeluaran akan menunggu persetujuan supervisor.</DialogDescription></DialogHeader>
        {open && <ExpenseForm onSaved={() => { setOpen(false); onSaved?.(); }} />}
      </DialogContent>
    </Dialog>
  </>;
};
